<template>
 <transition name="bounce">
  <div v-show="visible" class="gsnModal bg-white" @click="onHideByClick">
    <div class="gsnCloseButton ">
      <RTCloseButton @close="onClose"/>
    </div>
    <slot></slot>
  </div>
  </transition>
</template>

<script>
import RTCloseButton from '@/components/RTCloseButton.vue'
export default {
  name: 'RTmodal',
  components:{
    RTCloseButton
  },
  props:{
    clickAndClose:{
      type:Boolean,
      default:true
    }
  },
  data: function() {
    return {
       visible:false
    };
  },
  methods:{
    show(){
      this.visible=true;
      this.toggleBodyClass('addClass', 'noscroll');
    },
    onHideByClick(){
      if(this.clickAndClose){
        this.hide();
      }
    },
    onClose(){
      this.hide();
    },
    hide(){
      this.toggleBodyClass('removeClass', 'noscroll');
      this.visible=false;
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  }
};
</script>

<style scoped type='text/css'>
.noscroll { overflow: hidden; }
.gsnModal{
  z-index:999999999!important;
  position:fixed;
  overflow-y: scroll;
  left:0;
  right:0;
  top:0;
  bottom:0;
  padding:3rem;
}

.gsnCloseButton{
  position: fixed;
  color: white;
  top: 0;
  right: 0;
  cursor: pointer;
  padding:1.5rem;
}

.bg-white{
  background: white;
}

.color-gradient{
	background-image: none;
	background: rgb(39, 27, 34);
	background: -moz-linear-gradient(50deg, rgba(39, 27, 34) 0%, rgba(255, 148, 223));
	background: -webkit-linear-gradient(50deg, rgba(239, 27, 34) 0%, rgba(255, 148, 223));
	background: linear-gradient(50deg, rgb(39, 27, 34), rgb(255, 148, 223)); /**66, 64, 110 */
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#271b22",endColorstr="#ff94df",GradientType=1);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

</style>